module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('MapsPage', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "markers": _vm.markers,
      "resource": _vm.resource
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1257637c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Dashboard/test.vue
// module id = 1695
// module chunks = 1